import { render, staticRenderFns } from "./Stopped.vue?vue&type=template&id=36ac5ea2&scoped=true&"
import script from "./Stopped.vue?vue&type=script&lang=js&"
export * from "./Stopped.vue?vue&type=script&lang=js&"
import style0 from "./Stopped.vue?vue&type=style&index=0&id=36ac5ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ac5ea2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ac5ea2')) {
      api.createRecord('36ac5ea2', component.options)
    } else {
      api.reload('36ac5ea2', component.options)
    }
    module.hot.accept("./Stopped.vue?vue&type=template&id=36ac5ea2&scoped=true&", function () {
      api.rerender('36ac5ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Stopped.vue"
export default component.exports